import { useEffect, useRef, useState } from 'react';
import { useCMS } from '@/hooks/useCMS';

const DEFAULT = {
  label: 'გამოხმაურება',
  heading: 'კლიენტები',
  trust_stats: [
    { value: '4.9', label: 'Google Rating', sub: '200+ შეფასება' },
    { value: '87%', label: 'განმეორებითი კლიენტი', sub: 'წლიურად' },
    { value: '5K+', label: 'კმაყოფილი კლიენტი', sub: '1999 წლიდან' },
  ],
  items: [
    { name: 'გიორგი მჭედლიძე', role: 'CEO, TBC Development', project: 'TBC Business Center', quote: 'Phoenix-მა მოგვაწოდა Laminam-ის ფილები. ხარისხი, ვადები და სერვისი — ყველაფერი სრულყოფილი იყო.', image: '' },
    { name: 'ნინო ქავთარაძე', role: 'არქიტექტორი, Studio N', project: 'Stamba Hotel', quote: 'Phoenix-ის შოურუმში ყოველთვის ვპოულობ იმას, რასაც ვეძებ. ექსპერტული კონსულტაცია პროექტის გარანტიაა.', image: '' },
    { name: 'დავით ბერიძე', role: 'გენ. დირექტორი, Beridze Construction', project: 'კომერციული კომპლექსი', quote: 'Phoenix არის ჩვენი ერთადერთი მომწოდებელი. მიწოდების სიჩქარე და ხარისხი — ეს გამოარჩევს მათ.', image: '' },
  ],
};

export default function TestimonialsSection() {
  const sectionRef = useRef<HTMLDivElement>(null);
  const [active, setActive] = useState(0);
  const d = useCMS('testimonials', DEFAULT);
  const items: any[] = d.items || DEFAULT.items;
  const stats: any[] = d.trust_stats || DEFAULT.trust_stats;

  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) { entry.target.classList.add('animate-fade-up'); observer.unobserve(entry.target); }
      });
    }, { threshold: 0.1 });
    const els = sectionRef.current?.querySelectorAll('.reveal');
    els?.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  const cur = items[active] || items[0] || {};

  return (
    <section ref={sectionRef} className="bg-[#1C1C1C] py-24 md:py-32 overflow-hidden">
      <div className="max-w-7xl mx-auto px-8 md:px-14">
        <div className="reveal opacity-0 flex items-end justify-between mb-16 border-b border-white/8 pb-8">
          <div>
            <span className="text-[10px] font-bold tracking-[0.35em] uppercase text-[#ec3145] block mb-3">{d.label}</span>
            <h2 className="font-serif text-4xl md:text-5xl font-bold text-white">{d.heading}</h2>
          </div>
          <div className="flex items-center gap-2">
            {items.map((_: any, i: number) => (
              <button key={i} onClick={() => setActive(i)} className={`transition-all duration-300 cursor-pointer ${i === active ? 'w-8 h-px bg-[#ec3145]' : 'w-4 h-px bg-white/20 hover:bg-white/40'}`} />
            ))}
          </div>
        </div>
        <div className="reveal opacity-0 grid grid-cols-1 lg:grid-cols-12 gap-12 items-start">
          <div className="lg:col-span-8">
            <div className="text-[#ec3145] font-serif text-6xl leading-none mb-6 select-none">&ldquo;</div>
            <blockquote className="font-serif text-2xl md:text-3xl text-white/85 leading-relaxed mb-10">{cur.quote}</blockquote>
            <div className="flex items-center gap-5">
              {cur.image && <div className="w-12 h-12 rounded-full overflow-hidden flex-shrink-0"><img src={cur.image} alt={cur.name} className="w-full h-full object-cover" /></div>}
              <div>
                <div className="text-white font-semibold text-sm">{cur.name}</div>
                <div className="text-white/40 text-xs mt-0.5">{cur.role}</div>
                <div className="text-[#ec3145] text-xs mt-0.5 font-medium">{cur.project}</div>
              </div>
            </div>
          </div>
          <div className="lg:col-span-4 flex flex-col gap-8 lg:border-l border-white/8 lg:pl-12">
            {stats.map((s: any, i: number) => (
              <div key={i}>
                <div className="font-serif text-4xl font-bold text-white">{s.value}</div>
                <div className="text-white/60 text-sm mt-1">{s.label}</div>
                <div className="text-white/25 text-xs mt-0.5">{s.sub}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
